import { isValidUuidV4 } from '../../utils/text/validation';

/**
 * Returns UUID of current project, or undefined if URL is not a valid project URL.
 */
export const getSelectedProjectId = (): string | undefined => {
  const matches = /\/projects\/([^/]+)\/?/i.exec(window.location.pathname);
  const uuid = matches?.[1];
  return isValidUuidV4(uuid) ? uuid : undefined;
};

/**
 * Returns UUID of shared folder, or undefined if URL is not a valid shared folder URL.
 */
export const getSharedFolderId = (): string | undefined => {
  const matches = /^\/shared-folder\/([^/]+)\/?/i.exec(window.location.pathname);
  const uuid = matches?.[1];
  return isValidUuidV4(uuid) ? uuid : undefined;
};

/**
 * Returns UUID of shared view, or undefined if URL is not a valid shared view URL.
 */
export const getSharedViewId = (): string | undefined => {
  const matches = /^\/viewer\/shared\/([^/]+)\/?/i.exec(window.location.pathname);
  const uuid = matches?.[1];
  return isValidUuidV4(uuid) ? uuid : undefined;
};

/**
 * Returns true if URL is a shared viewer URL.
 */
export const isSharedViewerUrl = (): boolean => {
  return getSharedViewId() !== undefined;
};

const PUBLIC_REGISTRATION_ROUTES = [
  '/registercompany',
  '/register-design',
  '/newcompanyadmin',
  '/passwordreset',
];

/**
 * Returns true if the current URL is a public registration route that does not require authentication.
 */
export const isPublicRegistrationRoute = (): boolean => {
  const pathname = typeof window !== 'undefined' ? window.location?.pathname ?? '' : '';
  return PUBLIC_REGISTRATION_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
};
